import {GenericException} from './GenericException';

export class BusinessException extends GenericException {}

